const middleIndexNoTag = (text: string) => {
  const NEW_LINE = '\r\n';
  // Find the middle index
  const middleIndex = Math.floor(text.length / 2);

  // Find the closest \r\n before the middle index
  const beforeMiddle = text.lastIndexOf(NEW_LINE, middleIndex);
  // Find the closest \r\n after the middle index
  const afterMiddle = text.indexOf(NEW_LINE, middleIndex);
  // Determine which is closer to the middle
  const closest = middleIndex - beforeMiddle <= afterMiddle - middleIndex ? beforeMiddle : afterMiddle;

  //edge cases
  const splitted = text.split(NEW_LINE);
  if (splitted.length === 1) {
    return middleIndex;
  }
  if (splitted.length === 2 && splitted[0].length === splitted[1].length) {
    return middleIndex;
  }

  return closest;
};

export const splitSkillContext = (text: string) => {
  const middle = middleIndexNoTag(text);
  const first = text.slice(0, middle);
  const second = text.slice(middle, text.length);
  return { first, second };
};
